import React from "react";
import { BlocksRenderer } from "../../components/BlockRenderer";
import { imageBaseURL } from "../../utils/fetchData";

const AboutPart = ({ data }) => {
  return (
    <div className="content-section white-bg pt-30">
      <div className="course-overview">
        <div className="inner-box">
          <div className="row rs-team style1 orange-color transparent-bg">
            <div className="col-lg-12 col-md-8 col-sm-12">
              <div className="mb-20">
                {data?.obj && (
                  <img
                    src={
                      imageBaseURL +
                      data?.obj?.attributes?.Image?.data?.attributes?.url ||
                      ""
                    }
                    title={data?.obj?.attributes?.Name} alt={data?.obj?.attributes?.Name}
                  />
                )}
              </div>
              <h3 className="pName" title={data?.obj?.attributes?.Name}>{data?.obj?.attributes?.Name}</h3>
              <h3 title={data?.obj?.attributes?.Title}>{data?.obj?.attributes?.Title}</h3>
              <div style={{color: 'black'}}>
                <div className="subTitle">
                  <BlocksRenderer
                    content={data?.obj?.attributes?.Designation || []}
                  />
                </div>
              </div>

            </div>
          </div>
          <BlocksRenderer content={data?.obj?.attributes?.Body || []} />
        </div>
      </div>
    </div>
  );
};

export default AboutPart;
